import { onLocaleChange } from './index';
/**
 * Drop `new LocaleController(this)` into a Lit element's constructor and it
 * re-renders whenever the language changes, so its t() calls reflect the new
 * locale instantly — no per-component event wiring. Auto-unsubscribes on
 * disconnect. (The vanilla symbol grid uses onLocaleChange directly instead.)
 */
export class LocaleController {
    constructor(host) {
        this.host = host;
        host.addController(this);
    }
    hostConnected() {
        this.unsub = onLocaleChange(() => this.host.requestUpdate());
    }
    hostDisconnected() {
        this.unsub?.();
        this.unsub = undefined;
    }
}
//# sourceMappingURL=LocaleController.js.map